<template>
  <v-container fluid class="" >
    <v-card class="elevation-2 py-0 px-0 mt-4 rounded-lg d-flex flex-column justify-centers" >
      <v-card-text>
        <span class="danger">Are you sure you want to delete the contact?</span>
      </v-card-text>
      <v-form ref="form"  lazy-validation class="ml-5 mr-5 w-50 form-width w100 "
              id="id_formEditRuralContact"
      >

        <v-btn class="mr-4 white--text" @click="submit" color="indigo" block >
          Delete
        </v-btn>
      </v-form>
      <v-row class="mt-5"></v-row>
    </v-card>

  </v-container>
</template>


<script>

import instance from "@/api/axios-auth";

export default {
  name: "RuralContactDeleteForm",
  props: ['IdContact'],
  data() {
    return {
      field1: '',
      field2: '',
      field3: '',
      field4: '',
    };
  },
  methods: {
    updateField1(value) {
      this.field1 = value;
    },
    updateField2(value) {
      this.field2 = value;
    },
    updateField3(value) {
      this.field3 = value;
    },
    updateField4(value) {
      this.field4 = value;
    },
    submit(){
      if (!this.IdContact){
        return;
      }

      instance.post(`/rural/delete-contact/${this.IdContact}`, {} ).then(() => {
        this.$emit('closeModal');
      })

    }
  }
}
</script>


<style scoped>
.danger{
  color: #c91616;
  display: block; /* To ensure the span takes full width */
  text-align: center;
  font-size: 1.2em;
}
</style>
